import styled, { css } from 'styled-components';

import {
  borderRadius,
  colorUsage,
  fontSize,
  fontWeight,
  getSpacing,
  lineHeight,
} from 'stylesheetB2c';

interface ButtonProps {
  light?: boolean;
  lighter?: boolean;
}

const Button = styled.button<ButtonProps>`
  padding: ${getSpacing(2)} ${getSpacing(4)};

  font-weight: ${fontWeight.bold};
  font-size: ${(props) => (props.light ? fontSize.XSmall : fontSize.small)};
  line-height: ${lineHeight.medium};

  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
    `}

  border: none;
  border-radius: ${borderRadius.medium};

  text-decoration: none;

  color: ${colorUsage.primaryButtonColor};
  background-color: ${(props) =>
    props.disabled
      ? colorUsage.primaryButtonBackgroundDisabled
      : colorUsage.primaryButtonBackground};
  transition: ${(props) => (props.light ? 'none' : 'background-color 0.3s ease-in-out')};

  &:hover {
    background-color: ${(props) => {
      if (props.disabled) {
        return colorUsage.primaryButtonBackgroundDisabled;
      }
      if (props.light || props.lighter) {
        return colorUsage.lightButtonBackground;
      }
      return colorUsage.primaryButtonBackgroundHover;
    }};
  }

  &:focus {
    outline: thin dotted;
  }
`;

export default Button;
